import React, { useState, useEffect } from "react";
import { Box, Typography, LinearProgress } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { DotLottieReact } from '@lottiefiles/dotlottie-react';

const UserLoader = () => {
  const theme = useTheme();

  const [statusIndex, setStatusIndex] = useState(0);

  const statuses = [
    "CONNECTING TO USER DIRECTORY",
    "VERIFYING PERMISSIONS",
    "MAPPING ORGANIZATIONAL HIERARCHY",
    "POLLING ACTIVE SESSIONS",
    "FINALIZING USER PROFILES",
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setStatusIndex((prev) => (prev + 1) % statuses.length);
    }, 3000);

    return () => clearInterval(interval);
  }, []);

  return (
    <Box
      sx={{
        height: "80vh",
        width: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        bgcolor: "background.default",
        position: "relative",
      }}
    >
      {/* ===== LOTTIE ANIMATION ===== */}
      <Box sx={{ width: 300, height: 300, mb: 3 }}>
        <DotLottieReact
          src="https://lottie.host/ed828bd3-7e0b-4bf2-bba2-d47a23bea37a/opnT9z4M95.lottie"
          loop
          autoplay
        />
      </Box>

      {/* ===== TEXT ===== */}
      <Box sx={{ textAlign: "center", width: "100%", maxWidth: 300 }}>
        <Typography
          sx={{
            fontSize: 14,
            fontWeight: 900,
            letterSpacing: "3px",
            mb: 2,
            textTransform: "uppercase",
          }}
        >
          User Registry
        </Typography>

        <LinearProgress
          sx={{
            height: 2,
            borderRadius: 1,
            bgcolor: "#E2E8F0",
            "& .MuiLinearProgress-bar": {
              bgcolor: "primary.main",
            },
            mb: 2,
          }}
        />

        <Typography
          sx={{
            fontSize: 10,
            color: "text.secondary",
            fontWeight: 700,
            letterSpacing: "1px",
          }}
        >
          {statuses[statusIndex]}
        </Typography>
      </Box>

      {/* ===== FOOTER ===== */}
      <Box
        sx={{
          position: "absolute",
          bottom: 24,
          right: 24,
          opacity: 0.3,
          fontFamily: "monospace",
          fontSize: 9,
          lineHeight: 1.6,
          textAlign: "right",
        }}
      >
        NODE: AD_DIRECTORY_01
        <br />
        AUTH_METHOD: OIDC_SECURE
        <br />
        SYNC_PRIORITY: CRITICAL
      </Box>
    </Box>
  );
};

export default UserLoader;
